import React, {useState, useEffect} from 'react';

const Cheats = props => {
    const [visible, setVisible] = useState(true);

    const toggleVisibility = () => {
        setVisible(!visible);
    }

    return (
        <div className={`Cheats ${visible ? 'visible' : 'hidden'}`}>
            <div className={`visibility-toggle`} onClick={toggleVisibility} >{visible ? 'Hide' : 'Show'} Cheats</div>
            <button onClick={() => {
                props.setTargetSpeed(0)
                props.setSpeed(0)
                props.checkPosition();
            }}>Emergency Break</button>
            <button onClick={props.crossingComplete}>Complete Crossing</button>
        </div>
    )
}

export default Cheats